export const copy = {
  button: "End live chat",
  modal: {
    header: "Are you sure you want to end this chat?",
    body: "Ending the chat means you will not receive follow-up messages pertaining to this chat. You cannot undo this action.",
    actions: {
      confirm: "Confirm",
      close: "Close",
    },
  },
};
